/**
 * author: duxin
 * date: 2020/4/23
 * describe:
 */

const zh = {
    menu: {
        home: "首页",
        service: "服务内容",
        info: "资讯中心",
        about: "关于我们",
        job: "加入我们",
        contact: "联系我们",
        lang: "English",

        clinical: "临床运营",
        pharmaceutical: "药政事务",
        affairs: "医学事务",
        management: "数据管理&统计分析",
        call: "药物警戒&呼叫中心",
        auditing: "质量保证&稽查",
        patient: "中心 & 患者管理",
        drug: "I期药物临床试验中心",
        diagnosis: "中心影像",
        medical: "医学和临床策略",
        food: "国际事务",
        partner: "投资/伙伴数据库",
        FSP: "FSP",

        company: "公司新闻",
        industry: "行业新闻",
        book: "新书推荐",

        companyInfo: "公司简介",
        children: "子公司",
    },
    home: {
        about: "关于我们",
        content1: `科林利康`,
        content11: `医药临床试验领域的卓越专家`,
        content12: `全方位医学科技服务商`,
        content2: "科林利康总部位于中国苏州，在北京、上海、广州、天津、成都、西安、沈阳、南京、杭州和郑州等地设有实体办公室及20多个城市有驻地监查员。美国、英国、加拿大、新加坡等地设有海外办事处。目前拥有1000+的国际化专业团队。",
        content3: "科林利康以优质服务和合理的价格迅速成长为中国主要临床试验合同研究组织之一。我们帮助客户和合作伙伴开展临床试验项目，加速他们安全有效医药产品问世和医药研发投资回报最大化，进而使我们在许多医疗领域，如肿瘤、心血管等，积累了丰富的临床研究经验。",
        values: "我们的核心价值观",
        valuesText: "质量、诚信、效率、仁爱",
        mission: "我们的使命",
        missionText: "以质量为本，服务医药产品研发，助力人类更健康",
        vision: "我们的目标",
        visionText: "立足中国，成为医药临床研究领域的多元化功能国际服务商",

        seeMore: "查看更多",

        services: "我们的服务",

        information: "我们的资讯",

        banner1: "世界大同，您我同行",
        banner2: "临床试验的全方位服务",

    },
    about: {
        content1: "苏州科林利康医药科技股份有限公司（以下简称“科林利康”）是一家集临床运营、药政注册、医学写作、生物统计和数据管理、药物警戒、呼叫中心、质量保证、培训和咨询服务为己任的全方位医学科技服务商。",
        content2: "科林利康总部位于中国苏州，在北京、上海、广州、天津、成都、西安、沈阳、南京、杭州和郑州等地设有实体办公室及20多个城市有驻地监查员。美国、英国、加拿大、新加坡等地设有海外办事处。目前拥有1000+的国际化专业团队。\n",
        content3: "自成立以来，科林利康积极参与国内外医学领域的临床研究与学术推广，为制药企业、权威学术机构、临床试验研究机构、专家、医生等提供临床专业化服务，帮助患者和社会更健康，并以优质服务和合理的价格迅速成长为中国主要临床试验合同研究组织之一。我们的客户和合作伙伴包括国内外药物、生物技术和医疗器械企业，以及学术和政府组织等。我们运用先进的临床试验理念和技术、临床治疗专业技能和优质服务，帮助客户和合作伙伴开展临床试验项目，加速他们安全有效医药产品问世和医药研发投资回报最大化，进而使我们在许多医疗领域，如肿瘤、心血管等，积累了丰富的临床研究经验。\n" +
            "我们的高层管理人员和特聘顾问有着国内外一流医药企业丰富的从业和管理经验，并在国际和国内临床试验领域享有一定的专家声誉。良好的服务使得我们85%左右的客户都会在与我们合作后希望扩大合作或增加采购我们的服务。",
        journey: "我们的历程",
        history2025: "3月科林利康正式完成股份制改造，更名为苏州科林利康医药科技股份有限公司",
        history2024: "总部成功迁址苏州，更名为苏州科林利康医药科技有限公司，增加马来西亚及日本子公司，收购质增检测分析实验室浦尔璟公司，成立了苏州博羚医药公司",
        history2023: "公司总部正式迁址苏州，设立美国、澳大利亚海外分公司",
        history2022: "科林利康获中国药科大学“毕业生优质就业基地授牌”，2022中国生命科学服务企业品牌评比中“，荣耀登上中国品牌100强的桂冠",
        history2021: "科林利康作为苏州工业园区重点扶持企业将总部迁至苏州",
        history2020: "呼叫中心建立，覆盖调差问卷、安全性信息收集、受试者用药访视提醒",
        history2019: "香港科林利康研究有限公司及台湾分公司成立，香港及台北的临床运营及统计编程服务",
        history2017: "设立新加坡办公室，开拓亚太区业务，成立I期药物临床试验中心",
        history2016: "成立科睿克，SMO部门单独成立科睿克技术有限公司",
        history2015: "成立科林利康（苏州），早期研究、中心影像、中心病理，境外注册、Ⅰ期病房托管",
        history2014: "成立美达,美达临床数据技术有限公司成立提供专业数据服务，质量管理体系升级为V2.0",
        history2009: "创始元年，定位为一家提供临床试验全过程服务的CRO(北京科林利康医学技术服务中心)",

        honor: "我们的荣誉",
        honor2014: ["2014中国医学科学院肿瘤医院年度临床试验质控评选优秀团队"],
        honor2015: ["2015中国医学科学院肿瘤医院年度临床试验质控评选优秀团队"],
        honor2016: ["美达数据获得创新创业大赛西北赛区一等奖", "2016中国医学科学院肿瘤医院年度临床试验质控评选优秀团队"],
        honor2018: ["高新技术企业"],
        honor2019: ["成为中国化学制药工业协会会员单位", "1人被聘为中国抗癌协会第一届中西医整合肿瘤专业委员会早期临床试验研究组副组长，7人被聘为委员。", "1人被聘为第一届临床研究委员会委员","荣获中国医药创新促进会会员证书"],
        honor2020: ["荣获“第七届中国行业影响力品牌峰会”品牌榜入围企业"],
        honor2021: ["荣获中国生物医药产业链创新风云榜金马奖"],
        honor2022: ["荣获“2022中国生命科学服务企业品牌100强”称号", "中国医药创新促进会医药创新投资专业委员会"],
        honor2023: ["荣获年度影响力临床CRO企业", "苏州工业园区上市苗圃企业"],
        honor2024: ["苏州工业园区科技领军人才（成长）项目", "高新技术企业证书"],
        honor2025: ["企业信用管理体系贯标证书", "荣获四川大学华西医药国家药物临床试验机构最佳合作伙伴-项目总数", "荣获2025中国临床CRO排名TOP20","江苏省质量信用A级企业", "江苏省创新型中小企业", "江苏省专精特新中小企业"],

        team: "我们的团队",

        meta: "美达临床数据技术有限公司是一家科林利康全资的子公司，为国内外制药企业提供临床数据管理、生物统计、统计编程、药物警戒和呼叫中心服务的合同研究组织。",
        metaName: "美达临床数据技术有限公司",
        CRiC: "科睿克（北京）临床医学研究有限公司是科林利康旗下的国内专业的临床试验现场管理组织。目前团队成员分布在全国50个以上的城市，覆盖了300余家机构，与多家机构结成战略合作伙伴。科睿克始终把质量放在首位，致力于寻求中国临床试验现场管理解决之道。从公司成立至今，所有科睿克人不断开拓创新，秉承高效高品质的原则，积极配合申办方、研究者完成每一个项目。我们已完成与正在进行的项目超过300个，其中30%为国际多中心项目，所负责的大部分项目接受了权威机构的稽查和省级药政监管当局，国家局的现场核查，获得申办方与研究中心一致好评。",
        CRiCName: "科睿克（北京）临床医学研究有限公司",
        sz: "科林利康（苏州）医学研究有限公司是苏州科林利康医药科技股份有限公司的全资子公司。业务范围包括早期临床研究、医学写作、医学监察、医学策略、第三方独立影像评估、中国及美国药政事务。我们拥有专业稳定的团队及良好的行业内资源，不断致力于为客户提供优质服务，达成客户产品开发的目标。",
        szName: "科林利康（苏州）医学研究有限公司",

        more: "了解更多",
        culture: "企业文化",
    },
    common: {
        companyName: "科林利康",
        companyNameAll: "苏州科林利康医药科技股份有限公司",
        companyInfo: "公司简介",
        children: "分公司",
    },
    // 联系我们
    contact: {
        contact: '联系我们',
        addBJ: '苏州总部服务热线',
        welcome: '欢迎致信',
        nameBJ: '北京办公室',
        regionalOffice: '区域办公室',
        infoBJ: '北京市朝阳区三间房南里四号院Dream2049产业园主楼C01栋302室 100024',
        nameSH: '上海办公室',
        infoSH: '上海市浦东新区向城路58号东方国际科技大厦20楼A室 200122\n电话：021-64729901',
        nameCD: '成都办公室',
        infoCD: '四川省成都市锦江区新光华街7号航天科技大厦2907  610041',
        nameGZ: '广州办公室',
        infoGZ: '广州市越秀区中山三路33号中华国际中心B座1506   510030',
        nameXiAn: '西安办公室',
        infoXiAn: '西安市未央区凤城三路与太华北路东南角汇景国际广场世纪未来中心2308室 710021',
        nameSY: '沈阳办公室',
        infoSY: '辽宁省沈阳市皇姑区北陵大街21号，平安财富中心1009室',
        nameNJ: '南京高淳办公室',
        infoNJ: '江苏高淳经济开发区古檀大道3号科创大楼307室  211300',
        nameSB: '南京市区办事处',
        infoSB: '南京市鼓楼区华侨路 56 号大地大厦 2303-2306 室',
        nameTJ: '天津办公室',
        infoTJ: '天津市南开区融汇广场金融街中心A座907',
        nameSZ: '苏州总部',
        infoSZ: '江苏省苏州市工业园区裕新路108号中科院药物所苏研院2层A211  215000\n电话：0512-67990267',
        nameTB: '台北办公室',
        infoTB: '台北市中山區民生東路三段2號7樓',
        nameHZ: '杭州办公室',
        infoHZ: '杭州市上城区花园兜街177号恒褀商务中心克拉天玺B座4幢12楼B005',
        nameWH: '武汉办公室',
        infoWH: '武汉市江汉区江汉北路南国中心T1栋22楼02号',
        nameZZ: '郑州办公室',
        infoZZ: '郑州市金水区姚砦路133号金成时代广场6号楼西门三层308单元',
        locateMe: '定位到我',
        geolocationNotSupported: '您的浏览器不支持地理位置定位',
        permissionDenied: '您拒绝了定位权限',
        positionUnavailable: '无法获取您的位置',
        geolocationTimeout: '定位超时，请重试',
        geolocationError: '定位失败，请稍后再试'
    },
    // 表单
    fromData: {
        name: '您的名称',
        position: '您的职位',
        company: '企业名称',
        email: '邮箱',
        phone: '联系电话',
        productName: '产品名字',
        productType: '产品类型',
        origin: '原产地',
        newOrGeneric: '新药或仿制药',
        cureSphere: '治疗领域',
        indication: '适应症',
        indicationZh: '计划在中国的适应症',
        stage: '中国以外的开发进展或分期',
        cooperativeIntention: '合作意向',
        remark: '其他信息',
        more: '更多',
        moreText: `* 为了帮助您在中国找到潜在的合作伙伴，我们可能会向可能匹配的第三方提供上述信息（部分或全部）。按发送即表示您同意我们的双方保密协议。`,
        btnText: '同意并发送',
        sendOk: '发送成功！',
        sendText: '我们会尽快与您取得联系，谢谢！',
        fromRules: '请填写正确信息',
        error: '错误',
        systemError: '系统错误',
        contact: '请填写以下表单，我们会尽快与您联系'
    },
    help: {
        helpWays: '我们可为您提供以下服务',
        company: '合作&伙伴',
        helpContent: '请尽可能详细地填写下面的表格，以便我们为您制定最佳匹配方案我们将评估您下面提供的信息，以了解您的业务需求，以便我们为您提供相匹配的数据和资源。',
    },
    join: {
        values: '我们的信念',
        quality: "不懈努力于科学与新型医药治疗之间的开创性探索，世界必将充满生机和健康",
        platform: `职业规划大师之见：
未来的世界：方向比努力重要，能力比知识重要，健康比成绩重要，生活比文凭重要，情商比智商重要。——清华大学校长
科林利康为每位员工提供了畅通的职业发展路径，入职科林利康的每位员工可以参加科林利康大学堂在线学习，职业路径设置明晰：
职业路径畅通：临床数据团队从初级临床数据管理员到部门总监；
多条职业路径选择：监查团队可从临床项目助理到临床监查主管、质量控制主管，或高级项目经理；
量身定做的职业路径：临床协调团队可从预备临床研究协调员到培训带教老师、大区经理、或高级项目经理。`,
        mission: '我们的愿景',
        missionText: '通过我们的临床试验专业高端人才的服务，提供高质量的试验数据结果，值得信赖的药物研发规程的标准和规范的工作业绩，使我们成为行业赞誉的临床试验领域卓越专家',
        joinTitle: '招贤纳才',
        find: "点击进入",
        team: "团队建设",
        teamContent: "我们尊重每一位员工，并倡导践行“简单开放、极致执行、团队协作、创业心态、拥抱变化”的团队管理文化。我们倡导健康丰富的团队活动和员工关怀，每年最少一次全体员工大型团建活动；重大节日有暖心的福利，也会在各地办公室举办小型庆祝派对；每个季度还会开展一次员工生日会；部门也会定期单独安排团建等等，始终致力于为优秀人才创造更轻松和谐、更富创造力、更具激情的工作环境和团队氛围。",


        career: "发展平台",
        careerContent: `未来的世界：方向比努力重要，能力比知识重要，健康比成绩重要，生活比文凭重要，情商比智商重要。
——清华大学校长
科林利康为每位员工提供了畅通明晰的职业发展路径，职业路径设置明晰：
职业路径畅通：临床数据团队从初级临床数据管理员到部门总监；
多条职业路径选择：监查团队可从临床项目助理到临床监查主管、质量控制主管，或高级项目经理；
量身定做的职业路径：临床协调团队可从预备临床研究协调员到培训带教老师、大区经理、或高级项目经理。`,

        talent: "人才培养",
        talentContent: `完善高效的培训体系，帮助各层级员工规划和设计培训课程、培训项目，助力企业实现专业人才、管理人才及复合型人才个性化发展战略。开设“科林利康大学堂”、“科林利康网络学院”等线上、线下平台，以此为依托，为员工提供多元化职业教育课程，有助于提升员工的工作能力和软技能等，促进员工成长、晋升。
与中国药科大学合作，联合培养临床药学方向专业硕士研究生。并与中国药科大学一起联合举办美国临床监查员认证培训，为中国制药研发企业和相关机构不断输送临床试验专业人才。`,
        application: '申请职位',
        more: '更多',
        jobDetail: '职位详情',
        jobDuties: '工作职责',
        jobRequirements: '任职要求',
        welfare: '福利信息',
        applicantName: '姓名',
        gender: '性别',
        birthday: '出生日期',
        mobile: '手机号码',
        email: '邮件地址',
        education: '学历',
        academy: '毕业院校',
        city: '期望工作城市',
        clinicalExperience: '是否有临床经验',
        file: '简历上传',
        male: '男',
        female: '女',
        yes: '是',
        no: '否',
        selectFile: '选择文件',
        desc: '只能上传pdf文件',
        submit: '提交',
        clinical: '苏州科林利康医药科技股份有限公司',
        meta: '美达临床数据技术有限公司',
        cric: '科睿克（北京）临床医学研究有限公司',
        specialist: '专科',
        undergraduate: '本科',
        master: '硕士',
        doctor: '博士',
    },
    // 底部
    footer: {
        company: 'Copyright © 2024 苏州科林利康医药科技股份有限公司 版权所有 ',
        // compangCode: '京ICP备19026739号-1',
        compangCode: '苏ICP备2024073443号-1',
        tel: '电话：0512-67990267',
        fax: '传真：0512-67990267',
        email: '邮箱：csc@clinicalservice.cn',
        web: '网址：www.clinicalservice.cn',
        address: '地址：中国（江苏）自由贸易试验区苏州片区苏州工业园区裕新路108号1号楼A栋2楼209室',
        code: '邮编：215000'
    }
};
export default zh;
